var map = {
	"./add_col_after.svg": "6400",
	"./add_col_before.svg": "0383",
	"./add_row_after.svg": "3f49",
	"./add_row_before.svg": "4b75",
	"./combine_cells.svg": "350c",
	"./delete_col.svg": "ff5a",
	"./delete_row.svg": "5ce0",
	"./delete_table.svg": "e93a",
	"./table.svg": "979b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";